<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { SaleOfferMessage } from '$storefront';

  defineProps({
    message: { type: Object as PropType<SaleOfferMessage>, required: true },
  });
</script>
<template>
  <article class="message">
    <div class="message__wrapper">
      <div class="message__avatar">
        <SfAvatar :avatar="message.avatar" :name="message.name || $t('Nieznany')" />
      </div>
      <div class="message__container">
        <header class="message__header">
          <div class="message__id">
            {{ '#' + message.id }}
          </div>
          <div class="message__author">
            {{ message.name || $t('Użytkownik usunięty') }}
          </div>
          <div class="message__date">
            {{ $t('Napisano') + ':' }}
            <SfDateTime time :value="message.created_at" />
          </div>
        </header>
        <div class="message__content" v-html="message.message" />
      </div>
    </div>
  </article>
</template>
<style scoped lang="scss">
  .message {
    background: var(--secondary-background);
    border-radius: var(--border-radius);
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 0.5rem;

    &__wrapper {
      display: flex;
      gap: 1rem;
      align-items: flex-start;
      width: 100%;
    }

    &__avatar {
      flex: 0 0;
      width: 3rem;

      --ui-avatar-border: var(--secondary-border-hover);
      --ui-avatar-background: var(--secondary-background-hover);
      --ui-avatar-color: var(--secondary-color-hover);
    }

    &__container {
      width: 100%;
    }

    &__header {
      position: relative;
      border-bottom: 1px solid var(--secondary-border-hover);
      padding-bottom: 0.25rem;
    }

    &__id {
      top: 0;
      right: 0;
      position: absolute;
      font-family: var(--font-family-mono);
      font-size: 0.675rem;
      color: var(--secondary-color);
    }

    &__content {
      font-size: 0.875rem;
    }

    &__author {
      font-weight: var(--font-weight-bold);
      font-size: 1rem;
    }

    &__date {
      color: var(--secondary-color);
      font-size: 0.675rem;
    }
  }
</style>
